import { PageRoute } from 'src/routes/routes-behind-login/page-route'

export const pagesWithReDeliveryLabel = [
  `${PageRoute.VESSELS}/:vesselId/${PageRoute.VESSEL_DASHBOARD}`,
]
